<template>
    <div class="reference-bottom-sheet" :style="props.positionStyle" ref="bottomSheetRef">
        <p class="title h5">{{ props.referenceInfo.title }}</p>
        <p class="content body-3--regular">{{ props.referenceInfo.content }}</p>
        <button class="close-btn h6" @click="handleCloseBtnClick">{{ t('button_close') }}</button>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import type { ReferenceInfo } from '../../types/proReport';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits(['close']);
const props = defineProps<{
    referenceInfo: ReferenceInfo;
    positionStyle: string | Record<string, string>;
}>();

const bottomSheetRef = ref<HTMLElement | null>(null);

const handleCloseBtnClick = () => {
    emit('close');
};

let justOpened = false;

const handleClickOutside = (e: MouseEvent) => {
    if (justOpened) {
        justOpened = false;
        return; // 첫 클릭은 무시
    }

    const el = bottomSheetRef.value;
    if (
        el &&
        !el.contains(e.target as Node) &&
        !(e.target as HTMLElement).classList.contains('reference-item') &&
        !(e.target as HTMLElement).classList.contains('reference-title')
    ) {
        emit('close');
    }
};

onMounted(() => {
    justOpened = true; // 마운트 되자마자 한 번은 무시
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.reference-bottom-sheet {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 3rem 1.5rem;
    box-shadow: 0px -20px 20px 0px #0000000d;
    background-color: $primary-white;
    border-radius: 2.5rem 2.5rem 0 0;
    z-index: 100;
    max-height: 60%;
    overflow-y: auto;
}

.title {
    padding-bottom: 0.5rem;
}

.close-btn {
    background: $grey-2;
    border-radius: 2.5rem;
    padding: 1.3rem 0;
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 3rem;
    color: $grey-7;
}
</style>
